module.exports = __webpack_public_path__ + "img/bg_2.adb15be6.jpg";